import React from 'react'
import { Row, Col } from 'react-bootstrap'
import QuickCards from '../components/dashboard/QuickCards'

const DashboardPage = () => {
  return (
    <div>
      <Row gutter={16}>
        <Col>
          <QuickCards />
        </Col>
      </Row>
    </div>
  )
}

export default DashboardPage
